import React, { useEffect, useState } from 'react';
import Confetti from 'react-confetti';
import { motion } from 'framer-motion';

const BookingThankYou = () => {
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
    const [showConfetti, setShowConfetti] = useState(true);
    const [bookingData, setBookingData] = useState(null);

    useEffect(() => {
        const updateSize = () => {
            setDimensions({ width: window.innerWidth, height: window.innerHeight });
        };
        updateSize();
        window.addEventListener('resize', updateSize);
        return () => window.removeEventListener('resize', updateSize);
    }, []);

    useEffect(() => {
        const timer = setTimeout(() => setShowConfetti(false), 5000);
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        const data = sessionStorage.getItem('bookingSuccessData');
        if (data) {
            setBookingData(JSON.parse(data));
        }
    }, []);

    const fullName = bookingData?.full_name || "Guest";
    const hotel = bookingData?.hotel || "our hotel";
    const startDate = bookingData?.start_date;
    const endDate = bookingData?.end_date;


    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-[#F2F1F0] text-[#144E73] text-center px-4">
            {showConfetti && <Confetti width={dimensions.width} height={dimensions.height} numberOfPieces={200} />}
            <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
            >
                <h1 className="text-5xl font-bold mb-6">🎉 Thank You, {fullName}!</h1>
                <p className="text-xl mb-4">Your reservation at <span className="font-semibold">{hotel}</span> has been received.</p>
                {startDate && endDate && (
                    <p className="text-md text-gray-700 mb-2">
                        Booking Dates: <span className="font-medium">{startDate}</span> to <span className="font-medium">{endDate}</span>
                    </p>
                )}
                <p className="text-sm text-gray-600 mb-6">
                    We’ll be in touch soon. Feel free to explore more or reach out with questions.
                </p>
                <a
                    href="/"
                    className="inline-block px-6 py-3 bg-[#F29E38] text-[#023059] font-semibold rounded-full hover:bg-opacity-90 transition"
                >
                    Return Home
                </a>
            </motion.div>
        </div>
    );
};

export default BookingThankYou;
